import { useEffect, useState } from 'react'
import PlaceHolderImg from '../../../assets/images/announcement-bg.png'
import Gradient from '../../../assets/images/gradient.svg'

import { Button } from 'react-bootstrap'
import { Pagination, A11y, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import './Announcement.scss'
import * as cs from '../../../Api/cs'
import useHeader from '../../../Helper/useHeader'
import { useNavigate } from 'react-router-dom'
import HomeBanner from '../../Home/HomeBanner/HomeBanner'
import { useDispatch, useSelector } from 'react-redux'
import { updateShowChat } from '../../../Redux/Slices/chat.slice'
import { updateWalletShow } from '../../../Redux/Slices/modal.slice'

const Announcement = () => {
    const [announcement, setAnnoucement] = useState([])
    const headers = useHeader()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userId } = useSelector(state => state.user)
    useEffect(() => {
        getAnnoucementList()
    }, []);

    console.log('userId', userId)

    const getAnnoucementList = async () => {
        const response = await cs.get('getannouncementforuser', 'announcement', null, headers)
        console.log('getAnnoucementList response', response)
        let filteredAnnouncement = response?.data?.data || [];
        if (userId) {
            filteredAnnouncement = filteredAnnouncement.filter(item => item.visibility === 'both' || item.visibility === 'login')
        }
        else {
            filteredAnnouncement = filteredAnnouncement.filter(item => item.visibility === 'both' || item.visibility === 'logout')
        }
        setAnnoucement(filteredAnnouncement)

    }

    const handleDetail = (item) => {
        if (item?.openLink === 'sameTab') {
            const path = new URL(item?.link).hash.substring(1); // Extracting the path part after '#'
            navigate(path);

        } else if (item?.openLink === 'newTab') {
            window.open(item?.link, '_blank')
        }
    }
  console.log('getAnnoucementList announcement', announcement)

    return (
        <>
            {announcement && announcement.length > 0 ? <div className='announcement-wrap-v2'>
                <div className='gradient'>
                    <img src={Gradient} alt='' />
                </div>
                <div className='main-wrapper'>
                    <div className='main-container' style={{ width: '100%' }}>
                        <div className='announcement'>
                            <Swiper
                                loop={true}
                                modules={[Pagination, A11y, Autoplay]}
                                autoplay={{
                                    delay: 50000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: true,
                                }}
                                pagination={{ clickable: true }}
                                onSwiper={(swiper) => console.log(swiper)}
                                onSlideChange={() => console.log('slide change')}
                                centeredSlides={true}
                                watchSlidesProgress={true}
                                spaceBetween={30}
                                breakpoints={{
                                    1500: {
                                        slidesPerView: 1.4
                                    },
                                    1250: {
                                        slidesPerView: 1.4
                                    },

                                    300: {
                                        slidesPerView: 1
                                    }
                                }}

                            >

                                {/* <SwiperSlide className='announcement-box-v2' >
                                    <img src="https://cntndr-live.s3.us-east-2.amazonaws.com/staging/public/image/jpeg/811552350512-join-a-battle-jpg" style={{
                                        width: 900,
                                        height: 250
                                    }} />
                                </SwiperSlide>
                                <SwiperSlide className='announcement-box-v2' >
                                    <img src="https://cntndr-live.s3.us-east-2.amazonaws.com/staging/public/image/jpeg/811552350512-join-a-battle-jpg" style={{
                                        width: 900,
                                        height: 250
                                    }} />
                                </SwiperSlide>
                                <SwiperSlide className='announcement-box-v2' >
                                    <img src="https://cntndr-live.s3.us-east-2.amazonaws.com/staging/public/image/jpeg/811552350512-join-a-battle-jpg" style={{
                                        width: 900,
                                        height: 250
                                    }} />
                                </SwiperSlide> */}
                                {announcement && announcement.length > 0 && announcement.map((item) => (
                                    <SwiperSlide className='announcement-box-v2' >
                                        <div className='clickable-wrap' style={{ margin: '0 auto'}} onClick={() => {
                                            dispatch(updateShowChat(false));
                                            dispatch(updateWalletShow(false))
                                        }}>

                                            <img style={{ cursor: 'pointer', borderRadius: 8, margin: '0 auto' }}
                                                onClick={() => {
                                                    handleDetail(item)
                                                }}
                                                src={item?.image ? item?.image : PlaceHolderImg}
                                                // src="https://cntndr-live.s3.us-east-2.amazonaws.com/staging/public/image/png/270725738821-banner-png"
                                                alt='' />

                                            <div className='announcement-info-wrap'>
                                                <div className='announcement-info'>
                                                    <div className='announcement-title'>{item?.headline || ''}</div>
                                                    <div className='announcement-description'>{item?.text || ''}</div>
                                                </div>

                                                {item?.link && item?.isButtonVisible === 'Yes' &&
                                                    <div className='detail-btn-wrap'>
                                                        <Button variant='primary'
                                                            onClick={() => {
                                                                handleDetail(item)
                                                            }}>
                                                            {item?.buttonTitle || 'Details'}
                                                        </Button>
                                                    </div>}
                                                {/* <div className='detail-btn-wrap'>
                                                    <Button variant='primary'
                                                        onClick={() => {
                                                            handleDetail(item)
                                                        }}>
                                                        {item?.buttonTitle || 'Details'}
                                                    </Button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}



                            </Swiper>
                        </div>
                    </div>
                </div>
            </div >
                :
                <HomeBanner />
            }
        </>
    )
}

export default Announcement